
    export default {
      mounted() {
        this.input = this.el.querySelector('input[name="value"]')
        this.holder = this.el.closest("[data-selected]")
        if (!this.input || !this.holder) return
        this._onInput = () => {
          // Same shape the server parses: plain digits with one
          // decimal point (a sign only for the zero/deselect path).
          // parseFloat alone would read "2.5.1", "2abc" or "1e9" as a
          // number and flip a row the server then refuses — a
          // rejection sends no diff, so the highlight would stick.
          const raw = this.input.value.trim().replace(/,/g, ".")
          if (!/^-?\d+(\.\d+)?$/.test(raw)) return
          const v = parseFloat(raw)
          const floor = parseFloat(this.el.dataset.selectFloor || this.input.min)
          let sel = null
          if (v <= 0) {
            // 0 previews as deselected only where the server treats
            // it that way (quantity mode); elsewhere it clamps back
            // to the minimum and keeps the selection.
            if (this.el.dataset.zeroDeselects === "true") sel = "false"
          } else if (!(floor > 0) || v >= floor) {
            sel = "true"
          }
          // 0 < v < floor: the server will reject — leave the
          // current state alone.
          if (sel === null) return
          this.holder.setAttribute("data-selected", sel)
          if (this.holder.hasAttribute("aria-selected")) {
            this.holder.setAttribute("aria-selected", sel)
          }
        }
        this.input.addEventListener("input", this._onInput)
      },
      destroyed() {
        if (this._onInput) this.input.removeEventListener("input", this._onInput)
      }
    }
  